import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper,
  Checkbox
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { rowDetailType } from "../../member/MemberTable";
//import Waveform from "../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../../API";
import ContractRejectRsnDialog from "./ContractRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";

// interface userDetailProps {
  
// }
interface MemberDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: rowDetailType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<rowDetailType>>;
  getMemberList: any;
}

const rowData: rowDetailType = {
  id: 0,
  email: "",
  name: "",
  gender: "",
  jumin: "",
  bank: "",
  bank_num: "",
  birth: "",
  phone: "",
  startDate: "",
  roles: []
};

const ContractConfirmDialog = (props: MemberDetailProps) => {
  // console.log("props", props);
  const [data, setData] = useState<rowDetailType>(rowData);

  const [auths, setAuths] = useState([]);

  const [documentFile, setDocumentFile] = useState([]);

  const [rejectPageOpen , setRejectPageOpen] = useState<boolean>(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    console.log('result.data.data',result.data.data)
    
  };

  const getDocumentFile = async (worker:string) => {
    await api.get("/getDocumentFile",{params:{email:email,worker:worker}})
      .then(response => {
        // console.log('getDocumentFile' ,response.data.datas)
        setDocumentFile(response.data.datas)
      })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
  }

  const contractReject = () => {
    setRejectPageOpen(true)
  }

  const [dialogSize , setDialogSize] = useState(false)
  const [photoUrl , setPhotoUrl] = useState("")

  const [documentFileName, setDocumentFileName] = useState("")

  const getDocumentFileInfo = async (idx:number, file_type:string, file_name:string) => {

    if(file_type === "photo"){
      setDialogSize(true);
      setPhotoUrl("http://121.135.229.125/api/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
      // setPhotoUrl("https://localhost:9680/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
    }else{
      // setPhotoUrl("")
      // console.log('pdf 클릭')
      setDialogSize(false)
      await api.get("/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type,{ responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
      })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
    }

  };

  const [confirmRole , setConfirmRole] = useState("")

  const getSampleFileInfo = async (idx:number, file_type:string) => {

    if(file_type === "photo"){
      setPhotoUrl(window.location.origin.replace(':3000',':9680')+"/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
      // setPhotoUrl("https://localhost:9680/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
    }else{
      setPhotoUrl("")
      await api.get("/sampleFileInfo?idx="+idx+"&file_type="+file_type)
      .then((res:any) => {console.log('sampleFileInfo res')})
      .catch((e:any) => console.log('sampleFileInfo error' , e));
    }

  };

  const documentConfirm = async (worker:string, confirmRole:string) => {

    if(confirmRole === ""){
      alert("문서검사 대상 권한 선택이 필요합니다")
      return ;
    }
      
    await api.post("/documentConfirm",{worker: worker, role:confirmRole,email:email})
    .then((response:any) => {alert("계약정보 및 문서검사가 완료되었습니다."); props.setDialogOpen(false); props.getMemberList();})
    .catch((e:any) => console.log('문서검사 실패. 서버오류' , e));
  }

  useEffect(() => {
    getAuths();
    // console.log("MemberDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      getDocumentFile(props.rowDetail.email)
      
    }
    
  }, [props.rowDetail]);

  return (
    <Box >
    <Dialog maxWidth={dialogSize ? "xl" : "md"} open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>사용자 상세정보</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
      <Box display="flex" justifyContent="center">
      

        <form>
        <Box display="flex">
          <Box sx={{width:"100%", margin:"8px"}}>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이메일</Box>
              <TextField
                id="email"
                 value={data.email}
                type="email"
                variant="standard"
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                InputProps={{
                  readOnly: true,
                }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이름</Box>
            <TextField
              id="name"
              value={data.name}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>

                </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>성별</Box>
            <TextField
              id="gender"
               value={data.gender}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>생년월일</Box>
            <TextField
              id="birth"
               value={data.birth}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>

            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              {/* <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>권한</Box>
            <TextField
              id="roles"
               value={data.roles}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              /> */}
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>가입일</Box>
              <TextField
                id="startDate"
                value={data.startDate}
                variant="standard"
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}/>

            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>주민번호</Box>
            <TextField
              id="jumin"
               value={data.jumin}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>전화번호</Box>
            <TextField
               id="phone"
               value={data.phone}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>
            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>은행명</Box>
            <TextField
              id="bank"
               value={data.bank}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>계좌번호</Box>
            <TextField
               id="bank_num"
               value={data.bank_num}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>
            </Box>
            </Box>
          </Box>

          <Box>
            <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>문서제출</Box>
            <Box sx={{width: "95%", border: "3px solid #3e36a5", borderRadius: "3px", margin: "12px", padding: "8px", display:"block" , justifyContent:"center"}}>

              {documentFile.length > 0 ? 
                <React.Fragment>
                  {documentFile.map((documentFile:any,idx:number) => 
                    {
                        return (
                          <Box key={idx+1} display="flex" sx={{marginBottom:"4px", marginLeft:"32px"}}>
                            <Box sx={{marginRight:"40px"}}>{documentFile.file_type === "photo" ? <PhotoIcon/> : <DescriptionIcon/>}</Box>
                            <Box sx={{width:"390px",fontWeight:700}}>{documentFile.origin_file_name}</Box>
                            <Box sx={{margin:"auto"}}>
                              <Button sx={{backgroundColor: (documentFile.file_type === "pdf"? "#2344d6" : "#ff9800"), fontWeight:700}} size="small" variant="contained" onClick={()=>{getDocumentFileInfo(documentFile.idx,documentFile.file_type,documentFile.origin_file_name); setDocumentFileName(documentFile.origin_file_name) ;}}>
                              {documentFile.file_type === "pdf" ? "다운": "확인"}
                              </Button>
                            </Box>
                          </Box>
                        )
                    }
                  )}
                </React.Fragment>
              :""}
            </Box>
          </Box>

          <Box>
            <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>문서검사 대상 권한</Box>
            {data.roles.map((v:any,idx:number) => (
              <Box key={idx+1} sx={{display:"flex",alignItems: "center"}}>
                {auths.map((auth:any,idx:number) =>{
                  // console.log('auth',auth)
                  if(v.role === auth.code)
                    return (<React.Fragment key={idx+1}><Checkbox onClick={(e:any)=>e.target.checked === true ? setConfirmRole(v.role) : setConfirmRole('')}></Checkbox><Box>{auth.code_nm}</Box></React.Fragment>);
                })}
              </Box>
            ))}
            
          </Box>
          
        </form>

        

        {dialogSize && photoUrl != "" ?
          <Box>
              <Box display="flex">
                <Box sx={{marginLeft:"18px", marginRight:"auto", marginBottom:"12px", fontWeight:700, fontSize: "16px"}}>이미지 : {documentFileName}</Box>
                {/* <Box><Button sx={{margin:"auto"}} variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button></Box> */}
                <Box><HighlightOffIcon sx={{cursor:"pointer", marginRight:"16px"}} onClick={()=> setDialogSize(false)} /></Box>
              </Box>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", width:"654px" , height:"654px", overflow: "auto"}}>
                {/* <img src={photoUrl} style={{width: "100%", height: "100%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}} /> */}
                <img src={photoUrl}  style={{width: "100%"}} />
                {/* <Button variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button> */}
              </Paper>
          </Box>:""}

      </Box>


        {/* </form> */}
      </DialogContent>
        

          <DialogActions>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                props.setDialogOpen(false);
              }}
            >
              취소
            </Button>
            <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                contractReject();
                props.setDialogOpen(true);
              }}
            >
              문서 검수반려
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                documentConfirm(data.email,confirmRole)
              }}
            >
              문서 검사완료
            </Button>
            </DialogActions>
      {/* 취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          // onClick={() => { */}
          {/* //   // sampleReject();
          //   setRejectPageOpen(true);
          // 
        > */}

          {/* 샘플 검수반려
        {/* </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}} */}
          {/* // onClick={() => { */}
          {/* //   sampleConfirm();
          //  */}
    </Dialog>
    {rejectPageOpen ? <ContractRejectRsnDialog email={data.email} setRejectPageOpen={setRejectPageOpen} getMemberList={props.getMemberList} /> : ""}
    </Box>
  );
};

export default ContractConfirmDialog;
